<template>
  <div>
    <button class="btn-vmodal btn btn-sm" @click="$modal.hide(name)">
      ❌
    </button>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'modal',
    },
  },
};
</script>

<style scoped>
.btn-vmodal {
	position: absolute;
	top: 0;
	right: 0;
}
</style>
